export default __webpack_public_path__ + "static/media/statusActive.c29eb4eb.svg";